import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const PLAYER_PROFILES_COLLECTION = 'playerProfiles';

// Subscribes to a player's cross-tournament stats doc. Returns null while
// loading/absent — a missing doc just means this profileId hasn't finished
// a tournament yet, which callers use as the "played at least one
// tournament" gate.
export function usePlayerProfile(profileId) {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (!profileId) {
      setProfile(null);
      return;
    }
    return onSnapshot(
      doc(db, PLAYER_PROFILES_COLLECTION, profileId),
      (snap) => setProfile(snap.exists() ? { id: snap.id, ...snap.data() } : null),
      console.error
    );
  }, [profileId]);

  return profile;
}
